import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const CreatePortfolio = createAsyncThunk(
  "createPortfolio",
  async (arg, { rejectWithValue }) => {
    
    try {
      const response = await doPost(urls?.createPortfolio, arg);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const CreatePortfolioSlice = createSlice({
  name: "createPortfolio",
  initialState: {
    isLoading: false,
    success: false,
    error: null,
    data: false,
  },
  reducers: {
    createPortfolioReset: () => {
      return {
        isLoading: false,
        success: false,
        error: null,
        data: false,
      };
    },
  },
  extraReducers: {
    [CreatePortfolio.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.success = true;
      state.error = null;
      state.data = payload;
    },
    [CreatePortfolio.pending]: (state) => {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    [CreatePortfolio.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.data = false;
    },
  },
});

export const { createPortfolioReset } = CreatePortfolioSlice.actions;
